import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/workflows/user-workflow-documents/{userWorkflowDocumentId}/trigger-validation';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['POST'];
type Input = THIS_API['params'];
type Output = THIS_API['response'];

/** Triggers an on-demand AI review for a filing packet document. */
const triggerDocumentValidation = async ({ userWorkflowDocumentId }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>(PATH_TEMPLATE, { userWorkflowDocumentId });
  const response = await noodleApiClient.post(path);
  return response.data;
};

export default triggerDocumentValidation;
